import { Injectable } from '@angular/core';
import { CommonService } from '@app/shared/services/common.service';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class FeatureService {

  private allFeatures = {};

  constructor(private commonService: CommonService) { }

  getFeatures(serviceId) {
    let featuresSub = new BehaviorSubject([]);
    let features = this.allFeatures[serviceId];
    if (features)
      featuresSub.next(features);
    else
      this.commonService.getFeatures({ service: serviceId }).subscribe(res => {
        this.allFeatures[serviceId] = res.data;
        featuresSub.next(res.data);
      });
    return featuresSub;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/feature.service.ts